import { z } from 'zod'

const schema = z.object({
  /** ORIGEM da API, sem /v1 — os paths do código já o carregam. */
  VITE_API_BASE_URL: z.string().default(''),
  VITE_KEYCLOAK_URL: z.url(),
  VITE_KEYCLOAK_REALM: z.string().min(1),
  /** Com quem o SPA faz LOGIN (client público com PKCE). */
  VITE_KEYCLOAK_CLIENT_ID: z.string().min(1),
  /** O que o BACKEND exige no claim `aud` (client confidencial). Ver .env.example. */
  VITE_API_AUDIENCE: z.string().min(1),
  VITE_KEYCLOAK_REDIRECT_PATH: z.string().startsWith('/').default('/auth/callback'),
  VITE_KEYCLOAK_SCOPE: z.string().default('openid profile email'),
  VITE_APP_ENV: z.enum(['dev', 'staging', 'prod']).default('dev'),
})

/**
 * ⚠️ O Vite só substitui acessos ESTÁTICOS a `import.meta.env.VITE_X`.
 * `import.meta.env[chave]` num loop devolve undefined no BUILD e funciona em dev
 * — o pior tipo de bug. Por isso a listagem é manual e repetitiva de propósito.
 */
const raw = {
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
  VITE_KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL,
  VITE_KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM,
  VITE_KEYCLOAK_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  VITE_API_AUDIENCE: import.meta.env.VITE_API_AUDIENCE,
  VITE_KEYCLOAK_REDIRECT_PATH: import.meta.env.VITE_KEYCLOAK_REDIRECT_PATH,
  VITE_KEYCLOAK_SCOPE: import.meta.env.VITE_KEYCLOAK_SCOPE,
  VITE_APP_ENV: import.meta.env.VITE_APP_ENV,
}

const parsed = schema.safeParse(raw)
if (!parsed.success) {
  // Lançado no boot, antes do createRoot. O main.tsx renderiza isto em DOM cru —
  // config errada nunca deve virar tela branca sem pista.
  throw new Error(
    `Configuração de ambiente inválida (.env.local):\n\n${z.prettifyError(parsed.error)}\n\n` +
      `Copie .env.example para .env.local e preencha.`,
  )
}

export const env = Object.freeze(parsed.data)

// Guarda de pé-atrás: config de dev vazando para produção é falha comum e barata
// de barrar. Um bundle de prod apontando para 127.0.0.1 é build quebrado, não bug.
if (env.VITE_APP_ENV === 'prod' && env.VITE_API_BASE_URL.includes('127.0.0.1')) {
  throw new Error('VITE_API_BASE_URL aponta para 127.0.0.1 com VITE_APP_ENV=prod.')
}

// O /v1 pertence ao PATH, não à base. Com ele aqui, toda chamada vira
// /v1/v1/... e devolve 404 — e o sintoma (404 em tudo) não aponta a causa.
if (/\/v\d+\/?$/.test(env.VITE_API_BASE_URL)) {
  throw new Error(
    `VITE_API_BASE_URL não deve terminar em /v1 (valor: "${env.VITE_API_BASE_URL}").
` + 'Os paths do código já carregam o prefixo; repetir aqui gera /v1/v1/... → 404.',
  )
}
